import React from 'react';
import ErrorIcon from './icons/ErrorIcon';
import SuccessIcon from './icons/SuccessIcon';

const TrueFalseIcon = ({ flag }) => {
  return flag ? <SuccessIcon /> : <ErrorIcon />;
};

export default TrueFalseIcon;
